/**
 * COURE.HUB.DS.USSD.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DeleteResult } from '../model/deleteResult';
import { UssdCampaignPageModel } from '../model/ussdCampaignPageModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PagesService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param pageId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPagesChangeStateGet(pageId?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiPagesChangeStateGet(pageId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiPagesChangeStateGet(pageId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiPagesChangeStateGet(pageId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pageId !== undefined && pageId !== null) {
            queryParameters = queryParameters.set('pageId', <any>pageId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('get',`${this.basePath}/api/Pages/changeState`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPagesDeleteDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<DeleteResult>;
    public apiPagesDeleteDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeleteResult>>;
    public apiPagesDeleteDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeleteResult>>;
    public apiPagesDeleteDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DeleteResult>('delete',`${this.basePath}/api/Pages/delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param serviceProviderId 
     * @param ussdCampaignId 
     * @param pageName 
     * @param shortCode 
     * @param shortCodeKeyNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPagesDetailGet(id?: string, serviceProviderId?: string, ussdCampaignId?: string, pageName?: string, shortCode?: string, shortCodeKeyNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<UssdCampaignPageModel>;
    public apiPagesDetailGet(id?: string, serviceProviderId?: string, ussdCampaignId?: string, pageName?: string, shortCode?: string, shortCodeKeyNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UssdCampaignPageModel>>;
    public apiPagesDetailGet(id?: string, serviceProviderId?: string, ussdCampaignId?: string, pageName?: string, shortCode?: string, shortCodeKeyNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UssdCampaignPageModel>>;
    public apiPagesDetailGet(id?: string, serviceProviderId?: string, ussdCampaignId?: string, pageName?: string, shortCode?: string, shortCodeKeyNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('Id', <any>id);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('ServiceProviderId', <any>serviceProviderId);
        }
        if (ussdCampaignId !== undefined && ussdCampaignId !== null) {
            queryParameters = queryParameters.set('UssdCampaignId', <any>ussdCampaignId);
        }
        if (pageName !== undefined && pageName !== null) {
            queryParameters = queryParameters.set('PageName', <any>pageName);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('ShortCode', <any>shortCode);
        }
        if (shortCodeKeyNumber !== undefined && shortCodeKeyNumber !== null) {
            queryParameters = queryParameters.set('ShortCodeKeyNumber', <any>shortCodeKeyNumber);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UssdCampaignPageModel>('get',`${this.basePath}/api/Pages/detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param ussdCampaignId 
     * @param pageName 
     * @param shortCode 
     * @param startFrom 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPagesDetailsGet(serviceProviderId?: string, ussdCampaignId?: string, pageName?: string, shortCode?: string, startFrom?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<UssdCampaignPageModel>>;
    public apiPagesDetailsGet(serviceProviderId?: string, ussdCampaignId?: string, pageName?: string, shortCode?: string, startFrom?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UssdCampaignPageModel>>>;
    public apiPagesDetailsGet(serviceProviderId?: string, ussdCampaignId?: string, pageName?: string, shortCode?: string, startFrom?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UssdCampaignPageModel>>>;
    public apiPagesDetailsGet(serviceProviderId?: string, ussdCampaignId?: string, pageName?: string, shortCode?: string, startFrom?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('ServiceProviderId', <any>serviceProviderId);
        }
        if (ussdCampaignId !== undefined && ussdCampaignId !== null) {
            queryParameters = queryParameters.set('UssdCampaignId', <any>ussdCampaignId);
        }
        if (pageName !== undefined && pageName !== null) {
            queryParameters = queryParameters.set('PageName', <any>pageName);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('ShortCode', <any>shortCode);
        }
        if (startFrom !== undefined && startFrom !== null) {
            queryParameters = queryParameters.set('startFrom', <any>startFrom);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UssdCampaignPageModel>>('get',`${this.basePath}/api/Pages/details`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPagesInsertPost(body?: UssdCampaignPageModel, observe?: 'body', reportProgress?: boolean): Observable<UssdCampaignPageModel>;
    public apiPagesInsertPost(body?: UssdCampaignPageModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UssdCampaignPageModel>>;
    public apiPagesInsertPost(body?: UssdCampaignPageModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UssdCampaignPageModel>>;
    public apiPagesInsertPost(body?: UssdCampaignPageModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<UssdCampaignPageModel>('post',`${this.basePath}/api/Pages/insert`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPagesUpdatePut(body?: UssdCampaignPageModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiPagesUpdatePut(body?: UssdCampaignPageModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiPagesUpdatePut(body?: UssdCampaignPageModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiPagesUpdatePut(body?: UssdCampaignPageModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/Pages/update`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
